import { BadgeStatus } from '@cas/components/data-display/badge-dot/BadgeDot';
import StatusCell from '@cas/components/data-display/status-cell/StatusCell';
import { ReactElement } from 'react';
import { EmptyCell } from '../../formatters/genericFormatters';
import { RegisteredAssetModel } from '@casops/store/apis/registeredAssetsApi';
import { useTranslation } from 'react-i18next';

interface FaultLevelCellRendererProps {
  value?: number;
  data: RegisteredAssetModel;
}

export default function FaultLevelCellRenderer({
  value,
  data,
}: FaultLevelCellRendererProps): ReactElement | string {
  const { t } = useTranslation();
  if (typeof value !== 'number') {
    return EmptyCell;
  }

  let status: BadgeStatus;
  switch (value) {
    case 1:
      status = BadgeStatus.Danger;
      break;
    case 2:
      status = BadgeStatus.Warning;
      break;
    case 3:
      status = BadgeStatus.Caution;
      break;
    default:
      status = BadgeStatus.Danger;
  }

  return <StatusCell label={t('LevelNumber', { level: value })} status={status} />;
}
